(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-mundo"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(hm){
    if(hm.dataset.hmInit) return; hm.dataset.hmInit='1';
    var reduced=!!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches);
    var slides=[].slice.call(hm.querySelectorAll('.hm-slide'));
    if(!slides.length) return;
    var disc=hm.querySelector('.hm-disc'), dots=hm.querySelector('.hm-dots'), pp=hm.querySelector('.hm-pp');
    var i=slides.findIndex(function(s){return s.classList.contains('is-on');}); if(i<0)i=0;
    var side='left', animating=false, rafless=true;
    var speed=parseFloat(hm.dataset.autoplay||'0')*1000, auto=null, userStopped=reduced||!(speed>0);
    function acc(){ var c=slides[i].getAttribute('data-color')||'#ff3b3b'; hm.style.setProperty('--acc',c); try{document.documentElement.style.setProperty('--acc',c);}catch(e){} }
    function placeDisc(){ if(disc) disc.style.left = (side==='left'?'12%':'88%'); }
    function paint(){ slides.forEach(function(s,k){ s.classList.toggle('is-on',k===i); });
      if(dots)[].forEach.call(dots.children,function(d,k){ d.className=(k===i?'on':''); });
      acc(); }
    // dots
    if(dots){ slides.forEach(function(s,k){ var b=document.createElement('button'); if(k===i)b.className='on'; b.setAttribute('aria-label','Ir a la promoción '+(k+1)); b.addEventListener('click',function(){go(k);}); dots.appendChild(b); }); }
    placeDisc(); acc();
    function go(n){ n=((n%slides.length)+slides.length)%slides.length; if(n===i||animating) return;
      if(reduced){ i=n; paint(); placeDisc(); return; }
      animating=true; side=(side==='left')?'right':'left'; placeDisc(); if(disc)disc.classList.add('hm-dip');
      var cur=slides[i]; cur.classList.add('hm-swap');
      setTimeout(function(){ i=n; paint(); },300);
      setTimeout(function(){ cur.classList.remove('hm-swap'); if(disc)disc.classList.remove('hm-dip'); },540);
      setTimeout(function(){ animating=false; },900);
    }
    function next(){go(i+1);} function prev(){go(i-1);}
    var pv=hm.querySelector('.hm-prev'), nx=hm.querySelector('.hm-next');
    if(pv)pv.addEventListener('click',prev); if(nx)nx.addEventListener('click',next);
    function startAuto(){ if(!userStopped&&!auto&&speed>0) auto=setInterval(next,speed); }
    function stopAuto(){ if(auto){clearInterval(auto);auto=null;} }
    function setPP(p){ if(pp){ pp.textContent=p?'▶':'⏸'; pp.setAttribute('aria-label',p?'Reanudar':'Pausar'); } }
    startAuto();
    hm.addEventListener('mouseenter',function(){ userStopped=true; stopAuto(); setPP(true); });
    if(disc)disc.addEventListener('mouseenter',function(){ if(!reduced) next(); });
    if(pp)pp.addEventListener('click',function(){ if(auto){ userStopped=true; stopAuto(); setPP(true);} else { userStopped=false; startAuto(); setPP(false);} });
    var tsx=0;
    hm.addEventListener('touchstart',function(e){ tsx=e.changedTouches[0].clientX; },{passive:true});
    hm.addEventListener('touchend',function(e){ var dx=e.changedTouches[0].clientX-tsx; if(Math.abs(dx)>45){ dx<0?next():prev(); } },{passive:true});
    document.addEventListener('visibilitychange',function(){ if(document.hidden) stopAuto(); else startAuto(); });
  }
  function boot(){ [].forEach.call(document.querySelectorAll('.hm'), init); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
